import { useCompanyConfigQuery } from "../../SWR/Company/useCompanyConfigQuery";
import { useRegisterFormDataQuery } from "../../SWR/RegisterFormData/useRegisterFormDataQuery";
import { useAnalyticsLogging } from "../../Shared/hooks/useAnalyticsLogging/useAnalyticsLogging";
import { registerEvent } from "./registerUtils";
export const useRegisterForm = () => {
    var _a, _b, _c, _d;
    const { culture } = useCompanyConfigQuery();
    const { createKlaviyoEvent, logReactPixel, gaEvent } = useAnalyticsLogging();
    const defaultCountry = ((_c = (_a = culture.countryCode) !== null && _a !== void 0 ? _a : (_b = culture.cultureInfo) === null || _b === void 0 ? void 0 : _b.slice(-2)) !== null && _c !== void 0 ? _c : "US");
    const { referrals, shouldShowPrivacyPolicy, privacyPolicyBannerText, privacyPolicyUrl } = useRegisterFormDataQuery();
    return {
        defaultCountry,
        referrals: (_d = referrals === null || referrals === void 0 ? void 0 : referrals.sort((a, b) => a.referralId - b.referralId)) !== null && _d !== void 0 ? _d : [],
        shouldShowPrivacyPolicy: shouldShowPrivacyPolicy !== null && shouldShowPrivacyPolicy !== void 0 ? shouldShowPrivacyPolicy : false,
        privacyPolicyBannerText,
        privacyPolicyUrl,
        registerEvent: registerEvent(createKlaviyoEvent, logReactPixel, gaEvent),
    };
};
